import { render, staticRenderFns } from "./CommentSvg.vue?vue&type=template&id=3d6ecc19&"
import script from "./CommentSvg.vue?vue&type=script&lang=js&"
export * from "./CommentSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports